// extracted by mini-css-extract-plugin
export default {"loginInput":"styles_loginInput__PlHgp","gap":"styles_gap__Y3ObC"};